export default [{  // 请假单列表
	path: 'leave',
	name: 'm_app_leave_application',
	meta: {
		title: '请假单',
		keepAlive: true
	},
	component: () => import('@/pages/staff/affairs/leave_list')
}, {  // 请假单详情
	path: 'leave/detail',
	meta: {
		title: '请假单详情'
	},
	props: route => route.query,
	component: () => import('@/pages/staff/affairs/leave_detail')
}, {  // 请假单编辑
	path: 'leave/edit',
	meta: {
		title: '发起请假单'
	},
	props: route => route.query,
	component: () => import('@/pages/staff/affairs/leave_edit')
}, {  // 加班申请列表
	path: 'overtime',
	name: 'm_app_overtime_application',
	meta: {
		title: '加班申请',
		keepAlive: true
	},
	component: () => import('@/pages/staff/affairs/overtime_list')
}, {  // 加班申请详情
	path: 'overtime/detail',
	meta: {
		title: '加班申请详情'
	},
	props: route => route.query,
	component: () => import('@/pages/staff/affairs/overtime_detail')
}, {  // 加班申请编辑
	path: 'overtime/edit',
	meta: {
		title: '发起加班申请'
	},
	props: route => route.query,
	component: () => import('@/pages/staff/affairs/overtime_edit')
}];